import { AuthConfig } from "@flaminem/authentication";

import { env } from "src/core/env";

const authClients: Record<string, { realm: string; clientId: string }> = {
  // On devrait avoir le même client et le même realm quel que soit l'environnement.
  // Si ce n'est pas le cas, il faut voir avec l'infra pour qu'ils fassent les mises à jour.
  dev: {
    realm: "/auth/realms/kyc",
    clientId: "local-dev-front",
  },
  notairedev: {
    realm: "/auth/realms/kyc",
    clientId: "local-dev-front",
  },
  demo: {
    realm: "/auth/realms/kyc",
    clientId: "frontend-client",
  },
  prod: {
    realm: "/auth/realms/kyc",
    clientId: "frontend-client",
  },
};

const selectedClient = authClients[env.auth];

export const authConfig: AuthConfig = {
  authority: selectedClient.realm,
  clientId: selectedClient.clientId,
  scope: "openid profile email",
  responseType: "code",
  accessTokenExpiringNotificationTimeInSeconds: 60,
  redirectUri: window.location.origin,
  silentRedirectUri: window.location.origin,
  automaticSilentRenew: true,
  onSignInCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
